import React from 'react';
import { BasicTable } from '../shared/BasicTable/BasicTable';
import { InvoiceData } from '../../models/Invoice';
import { InvoiceDetailsDialogTitle } from '../shared/Typography/InvoiceDetailsDialogTitle';
import { useTranslation } from 'react-i18next';
import { InvoiceDetailsTableRow } from './InvoiceDetailsTableRow';
import { INVOICE_DETAILS_HEAD_CELLS } from '../../utils/constans/tableHeads/invoicesTableHead';

const InvoiceDetails: React.FC<{ invoice: InvoiceData }> = (props) => {
    const rows = [props.invoice];
    const { t } = useTranslation('invoices', {
        keyPrefix: 'INVOICE_DETAILS',
    });

    const tableHeadSettings = {
        translateNs: 'invoices',
        translatePrefix: 'INVOICES.TABLE_HEAD',
        selectable: false,
        headContent: INVOICE_DETAILS_HEAD_CELLS,
    };

    return (
        <>
            <InvoiceDetailsDialogTitle>
                {t('DETAILS_TITLE')}
            </InvoiceDetailsDialogTitle>
            <BasicTable<InvoiceData, InvoiceData>
                fullList={rows}
                tableHeadSettings={tableHeadSettings}
                component={InvoiceDetailsTableRow}
            />
        </>
    );
};

export default InvoiceDetails;
